import moment from 'moment';

const localeSort = (p1: string, p2: string) => {
  if (!p1) return -1;
  if (!p2) return 1;
  return p1.localeCompare(p2);
};

const dateSort = (p1: string, p2: string) => {
  if (!p1) return -1;
  if (!p2) return 1;

  return moment(p1).isAfter(p2) ? 1 : -1;
};

export { localeSort, dateSort };
